@if (gameType && gameInstance) {
    @if (gameType === GameType.DragonTiger || gameType === GameType.OpenDragonTiger) {
        <app-dragon-tiger-table [data]="gameInstance.view"></app-dragon-tiger-table>
    } @else if (gameType === GameType.Baccarat || gameType === GameType.OpenBaccarat) {
        <app-baccarat-table [data]="gameInstance.view"></app-baccarat-table>
    } @else if (gameType === GameType.ThreeHeadedDragon) {
        <app-three-headed-dragon-table [data]="gameInstance.view"></app-three-headed-dragon-table>
    }
} @else {
    <h2 i18n class="title-vertical-center title-error">Invalid game data</h2>
}
